export default {"src":"/_next/static/media/clementines.fdb1b235.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};